module.exports = __webpack_public_path__ + "static/media/icon-cog-ot.9bcef18c.svg";